module.exports = __webpack_public_path__ + "static/img/group-5.c3d5356.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/group-5.svg
// module id = ZDMp
// module chunks = 1